import { SlideFrame } from '../SlideFrame';

const TEAM = [
  { name: 'Steven Tuchner', role: 'CEO & Chief Investment Officer', desc: '30 years investing across global markets. Built the model. Makes every position decision.' },
  { name: 'Ornella Gubiani Parker', role: 'Chief Operating Officer', desc: 'Fund administration, operations, investor reporting. Independent of investment decisions.' },
  { name: 'Clement Messere', role: 'Business Development & Client Relations', desc: 'Manages institutional and private client relationships. 10-year partnership with Triumph.' },
  { name: 'The Visualizer', role: '24-hour research department', desc: 'Scores every company every morning. Watches every holding around the clock. Surfaces fresh ideas every day.' },
];

export function Slide17Team() {
  return (
    <SlideFrame pageNum={20} title="OUR TEAM" banner="Three people plus proprietary technology. The whole desk in one room.">
      <div className="grid grid-cols-4 gap-4 h-full items-stretch py-3">
        {TEAM.map(m => (
          <div key={m.name} className="bg-[#1e293b] rounded-2xl p-5 flex flex-col items-center justify-center text-center">
            <div className="text-[#c9a84c] text-[22px] font-bold mb-2 leading-tight">{m.name}</div>
            <div className="text-[#cbd5e1] italic text-[15px] mb-3 leading-snug">{m.role}</div>
            <div className="w-12 h-px bg-[#c9a84c]/40 mb-3" />
            <div className="text-white text-[15px] leading-snug">{m.desc}</div>
          </div>
        ))}
      </div>
    </SlideFrame>
  );
}
